import { render, staticRenderFns } from "./TourHome.vue?vue&type=template&id=93aed6b2&scoped=true&"
import script from "./TourHome.vue?vue&type=script&lang=js&"
export * from "./TourHome.vue?vue&type=script&lang=js&"
import style0 from "./TourHome.vue?vue&type=style&index=0&id=93aed6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aed6b2",
  null
  
)

export default component.exports